import * as EventEmitter from 'events';
import { createReduxStore } from '../redux/createStore';
import { prepareInitialState } from '../mappers/initialState';
import { prepareLayoutConfiguration } from '../mappers/layoutConfiguration';
import { Context } from './context';
export function createContext(parameters, preloadedState) {
  var httpApi = parameters.httpApi,
    logger = parameters.logger,
    config = parameters.config;
  var _prepareInitialState = prepareInitialState(preloadedState),
    initialState = _prepareInitialState.initialState,
    internalPreloadedFormState = _prepareInitialState.internalPreloadedFormState;
  var layoutConfiguration = prepareLayoutConfiguration(preloadedState);
  var emitter = new EventEmitter();
  var context = {
    httpApi: httpApi,
    logger: logger,
    emitter: emitter,
    config: config,
    layoutConfiguration: layoutConfiguration,
    internalPreloadedFormState: internalPreloadedFormState
  };
  var store = createReduxStore({
    context: context,
    initialState: initialState
  });
  return new Context(store, emitter, context);
}